/// <reference types="rm-cstyle-cmts"/>

import * as React from 'react';
// import PropTypes from 'prop-types';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from "@material-ui/core/Tooltip";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import { IconButtonProps } from '@material-ui/core/IconButton';
// import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";

import monaco from "monaco-editor/package.json";

// /**
//  * Button wrapped by Tooltip.
//  * 
//  * usage:
//  * + always use the same react virtual dom by using the same reference for `tooltipProps` and `buttonProps`
//  * 
//  * NOTE: **tooltip {focus,hover,toutch} event listener disabled**.
//  * 
//  *   -> `disableFocusListener` `disableHoverListener` `disableTouchListener`
//  * 
//  * @param props 
//  */
// const TooltipedButton = React.memo(
//     (props: {
//         /**
//          * 
//          * NOTE: avoid typescript type detection error. -> `Omit<TooltipProps, "children">`
//          */
//         tooltipProps: Omit<TooltipProps, "children">,
//         /**
//          * the IconButton props
//          */
//         buttonProps: IconButtonProps,
//         /**
//          * IconButton children.
//          */
//         children: React.ReactNode
//     }) => {
//         const [open, setOpenState] = React.useState(false);
//         const button = <IconButton {...props.buttonProps}
//             onClick={() => {
//                 setOpenState(!open);
//             }}
//         >{props.children}</IconButton>;
//         return <Tooltip open={open}
//             {...props.tooltipProps}
//             disableFocusListener disableHoverListener disableTouchListener
//             children={button}
//         />;
//     },
//     (pp, np) => {
//         return pp.buttonProps === np.buttonProps && pp.tooltipProps === np.tooltipProps;
//             //&& pp.children === np.children;
//     }
// );


const styles = createStyles({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -18,
    marginRight: 10,
  },
});


// type RmcSigParams = Parameters<IRemoveCStyleCommentsTypeSig>;
// export type RmcOptions = {
//   param1: RmcSigParams[1];
//   param2: RmcSigParams[2];
// }
export interface DenseAppBarProps extends WithStyles<typeof styles> {
  updateRemoveBlankLines?: (value: boolean) => void;
  updatePreserveJSDoc?: (value: boolean) => void;
}

const DenseAppBar = (props: DenseAppBarProps) => {

  const { classes } = props;
  const [removeBlanks, updateBlanksChecked] = React.useState(true);
  const [preservJSDoc, updatePreservJSDoc] = React.useState(false);

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <Tooltip title={<div style={{ whiteSpace: "pre-line", fontSize: "0.8125rem" }}>{
`can strip .js, .jsx, .ts, .tsx or .json

If can not process normally due to syntax error etc,
the input will be returned as it is

`}
<span style={{ color: "gold", fontWeight: "bold" }}>*left editor corresponds to load by file drop.</span>
</div>}>
            <IconButton className={classes.menuButton} color="inherit" aria-label="Menu">
              <Icon>dehaze</Icon>
            </IconButton>
          </Tooltip>
          <Typography variant="h6" color="inherit">
            rm-cstyle-cmts Playground
            <span style={{ fontSize: "0.7em" }}> (rm-cstyle-cmts@{
              Rmc.version
            }, monaco-editor@{
              // @ts-ignore 
              monaco.version
            })</span>
          </Typography>
          <div style={{ flexGrow: 1 }} />
          <FormControlLabel
            control={
              <Checkbox
                style={{ padding: 0, filter: "blur(0.6px)" }}
                checked={preservJSDoc}
                onChange={e => {
                  const value = e.target.checked;
                  updatePreservJSDoc(value);
                  props.updatePreserveJSDoc && props.updatePreserveJSDoc(value);
                }}
                // color="primary"
              />
            }
            label="preserve JSDoc"
          />
          <FormControlLabel
            control={
              <Checkbox
                style={{ padding: 0, filter: "blur(0.6px)" }}
                checked={removeBlanks}
                onChange={e => {
                  const value = e.target.checked;
                  updateBlanksChecked(value);
                  props.updateRemoveBlankLines && props.updateRemoveBlankLines(value);
                }}
                // color="primary"
              />
            }
            label="blank lines"
          />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default withStyles(styles)(DenseAppBar);
